import { useFormik } from 'formik'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createAdmin, getRoleList } from '../../actions/permissionsAction'
import CreateAdminView from "../../containers/AdminUsers/CreateAdmin/CreateAdmin"
const CreateAdmin = ({ history }) => {
  const dispatch = useDispatch()
  const { listRoleAdmin } = useSelector(state => state.permissionsAdmin)
  useEffect(() => {
    dispatch(getRoleList())

    return () => {

    }
  }, [])
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      password: "",
      gender: "",
      description: "",
      passwordConfirm: "",
      adminRoleId: "",
      birthDate: new Date()
    },
    onSubmit: (({ files, name, email, phone, password, gender, description, adminRoleId, birthDate }) => {
      const formData = new FormData()
      formData.append("files", files)
      formData.append("name", name)
      formData.append("email", email)
      formData.append("phone", phone)
      formData.append("password", password)
      formData.append("gender", gender)
      formData.append("description", description)
      formData.append("adminRoleId", adminRoleId)
      formData.append("birthDate", birthDate)
      dispatch(createAdmin(formData, history))

    })

  })
  return (
    <CreateAdminView  formik={formik} roles={listRoleAdmin} />
  )
}

export default CreateAdmin